<template>
    <div class="modal fade match-reminder-modal deposit-edit-stake-modal-box" id="singlestakeeditModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
          <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4>{{ $t('edit-stake', 'Edit Stake') }}</h4>
                      <!-- <button type="button" @click="resetChips()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
                  </div>
                  <div class="modal-body">
                      <div class="stakeed-sec withdraw-sec">
                          <div class="exch-setting-edit-stack-wrapper">
                              <form>
                                  <div class="deposit-edit-stake-field">
                                      <ul class="edit-stake-list">
                                         <template v-for="i in 4">
                                          <li>
                                         <input type="text" maxlength="8" v-model="stake[i-1]" @input="stake[i-1] = $helper.sanitizeNumber(stake[i-1], 10000000)" class="btn-thm form-control">
                                        </li>
                                    </template>
                                      </ul>
                                  </div>
                              </form>
                          </div>
                      </div>
                      <div class="info-footer">
                          <button @click="resetChips()" type="button" class="edit_stake_btn123" data-bs-dismiss="modal">{{$t('cancel','Cancel')}}</button>
                          <a @click="callChangeStakeValue()" class="save_stake_btn123">{{$t('save','Save')}}</a>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </template>
  <script>
  export default {
      name: "StackModal",
      props:['stakes'],
      data() {
        return {
            stake: this.$store.getters.userTransactionStakes || this.stakes
        };
    },
     mounted() {
        this.resetChips();
    },
      methods: {
           callChangeStakeValue() {
            if(Object.values(this.stake).some(item => item == '') || Object.values(this.stake).some(item => item < 100)){
                this.$errorToast('Stake value must be between 100 to 1Cr.')
                return
            }
            this.$store.dispatch('setUserTransactionStakes', JSON.parse(JSON.stringify(this.stake)));
            this.$successToast('Saved Successfully')
            this.$helper.closeModal('singlestakeeditModal');
        },
        resetChips(){
            this.stake = JSON.parse(JSON.stringify(this.$store.getters.userTransactionStakes || this.stakes));
        }
    }
  };
  </script>